
/* injects from baggage-loader */

'use strict';

import AccountSettingsComponent from './account.settings.component';

// Load child states
import AccountProfileSettings from './profile/account.settings.profile.module';
import AccountPasswordSettings from './password/account.settings.password.module';
import AccountPaymentSettings from './payments/account.settings.payments.module';
import AccountConnectedAccountsSettings from './connected-accounts/account.settings.connected-accounts.module';

const AccountSettingsPageModule = angular.module('account-settings-module', [
    'ui.router',

    // Inject child states
    AccountProfileSettings.name,
    AccountPasswordSettings.name,
    AccountPaymentSettings.name,
    AccountConnectedAccountsSettings.name

  ])
  .config(($stateProvider, $urlRouterProvider) => {
    'ngInject';

    $urlRouterProvider.otherwise('/');

    $stateProvider
      .state('account.settings', {
        url: '/settings',
        // Requires valid login to view
        protected: true,
        component: 'accountSettings',
        // Resolve promises into controller bindings, see component for bindings
        // resolve: {  }
      });
  })
  .component('accountSettings', new AccountSettingsComponent());

export default AccountSettingsPageModule;



// WEBPACK FOOTER //
// ./src/app/pages/account/settings/account.settings.module.js